import type { CPhotoGalleryTranslations } from "./pl";

/**
 * CPhotoGallery - English translations (Photo Gallery - gallery list + gallery).
 */
export const en: CPhotoGalleryTranslations = {
  emptyData: "No data to display.",
  emptyList: "No galleries to display.",
  emptyGallery: "This gallery has no photos yet.",
  backToList: "<- Back to gallery list",
  openImage: "Open image",
  /** `photosCount(5)` -> "5 photos". */
  photosCount: (n: number): string => `${n} ${n === 1 ? "photo" : "photos"}`,
  paginationAria: "Pagination",
  /** `paginationLabel(2, 7)` -> "Page 2 of 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Page ${page} of ${totalPages}`,
  paginationHint: "Pagination will be wired in a future iteration",
};
